import React from 'react';

export default function GetPolyLineIcon(type) {
  switch (type) {
    case 'solid':
      return (
        <svg width="32" height="32" viewBox="0 0 32 32">
          <rect x="2" y="14" width="28" height="4" rx="2" />
        </svg>
      );
    case 'arrows':
      return (
        <svg width="32" height="32" viewBox="0 0 32 32">
          <rect x="2" y="14" width="28" height="4" rx="2" />
          <path d="M21 20L29 24L21 28V20Z" />
          <path d="M10 6H18C19.1046 6 20 6.89543 20 8V8C20 9.10457 19.1046 10 18 10H10V6Z" />
          <path d="M11 24C11 22.8954 11.8954 22 13 22H21V26H13C11.8954 26 11 25.1046 11 24V24Z" />
          <path d="M2 8L10 4V12L2 8Z" />
        </svg>
      );
    case 'one_way':
      return (
        <svg width="32" height="32" viewBox="0 0 32 32">
          <rect width="32" height="32" fill="white" />
          <rect x="2" y="10" width="28" height="4" rx="2" />
          <path d="M21 16L29 20L21 24V16Z" />
          <path d="M11 20C11 18.8954 11.8954 18 13 18H21V22H13C11.8954 22 11 21.1046 11 20V20Z" />
        </svg>
      );
    case 'one_way_other':
      return (
        <svg width="32" height="32" viewBox="0 0 32 32">
          <rect x="2" y="18" width="28" height="4" rx="2" />
          <path d="M10 10H18C19.1046 10 20 10.8954 20 12V12C20 13.1046 19.1046 14 18 14H10V10Z" />
          <path d="M2 12L10 8V16L2 12Z" />
        </svg>
      );
    case 'temporary_break':
      return (
        <svg width="32" height="32" viewBox="0 0 32 32">
          <rect
            x="20.6504"
            y="18"
            width="12"
            height="4"
            rx="2"
            transform="rotate(-40 20.6504 18)"
          />
          <rect
            x="11"
            y="18"
            width="12"
            height="4"
            rx="2"
            transform="rotate(-40 11 18)"
          />
          <rect
            x="0.65036"
            y="18"
            width="12"
            height="4"
            rx="2"
            transform="rotate(-40 0.65036 18)"
          />
        </svg>
      );
    case 'dashed':
      return (
        <svg width="32" height="32" viewBox="0 0 32 32">
          <rect width="32" height="32" fill="white" />
          <rect x="22" y="14" width="8" height="4" rx="2" />
          <rect x="12" y="14" width="8" height="4" rx="2" />
          <rect x="2" y="14" width="8" height="4" rx="2" />
        </svg>
      );
    default: {
      return (
        <svg width="32px" height="32px" viewBox="0 0 32 32">
          <g transform="translate(8.000000, 6.000000)" fillRule="nonzero">
            <path
              d="M16.8007683,17.3682828 L15.399761,17.3682828 C15.399761,17.853596 15.4078592,18.2994747 15.399761,18.7453333 C15.3916628,19.1833131 15.2013523,19.5265859 14.7964268,19.7317576 C14.3834098,19.9448283 13.9582439,19.9329879 13.561439,19.692301 C13.1970171,19.4752909 13.0309976,19.1320182 13.0269549,18.7216545 C13.0229056,18.2836747 13.0269549,17.8417556 13.0269549,17.3840586 L3.98523537,17.3840586 L3.98523537,18.6545838 C3.98118626,19.3727051 3.49124024,19.8738162 2.79073659,19.8698566 C2.09427561,19.8698566 1.61647195,19.3845434 1.60838659,18.6703616 C1.60433748,18.2481798 1.60838659,17.8259778 1.60838659,17.3643414 L0.92407439,17.3643414 L0.211421951,17.3643414 L0.211421951,17.0447455 C0.211421951,14.4209071 0.195225305,11.7968667 0.223569488,9.17302828 C0.231667915,8.52593737 0.365289366,7.88278586 0.450332902,7.23963434 C0.628497049,5.90597778 0.830946317,4.57236162 0.984817049,3.23862424 C1.09009473,2.33504848 1.55979022,1.72347273 2.37367559,1.3091697 C3.28473046,0.847513131 4.26463534,0.610785859 5.26077315,0.417432323 C6.46337802,0.188583838 7.6741512,-0.00870909091 8.89690729,0.0662606061 C10.7676122,0.176741414 12.6099561,0.448987879 14.3551512,1.17106869 C15.4322256,1.61692727 15.9707731,2.38240202 16.0881975,3.52278586 C16.2623107,5.18787677 16.5214488,6.84500808 16.7401061,8.5062202 C16.7765483,8.78636162 16.8048927,9.07046263 16.8048927,9.35454343 C16.8008433,11.9113111 16.8008433,14.4602 16.8008433,17.0092909 L16.8008433,17.3683414 L16.8007683,17.3682828 Z M8.48776829,9.66626263 L14.4765366,9.66626263 C14.6061098,9.66626263 14.7397256,9.66231697 14.8692988,9.64258788 C15.1487,9.60313131 15.30255,9.42951717 15.3349537,9.16515354 C15.3551994,9.0033798 15.3471012,8.83371919 15.3228061,8.67194141 C15.1243975,7.28305253 14.9178951,5.89820404 14.7235354,4.51315354 C14.6223066,3.80293131 14.3753049,3.57802222 13.6424183,3.55434545 C13.5573851,3.5503998 13.472354,3.55434545 13.3873147,3.55434545 L4.00953417,3.55434545 C3.77468539,3.55434545 3.53983661,3.54645414 3.30498783,3.55829111 C2.61663295,3.59380222 2.38178417,3.81871535 2.28865734,4.48948303 C2.16718198,5.36148303 2.03355368,6.22954364 1.91208661,7.09756384 C1.82300454,7.74861434 1.72582466,8.40358404 1.66913173,9.05857394 C1.63673844,9.41762444 1.85134478,9.61491737 2.21980734,9.65833152 C2.32103612,9.67016869 2.4263138,9.66622283 2.53159149,9.66622283 L8.487811,9.66622283 L8.48776829,9.66626263 Z M8.50396494,2.58363636 L11.6906357,2.58363636 C11.812111,2.58363636 11.9376332,2.57574505 12.0510149,2.5441798 C12.2777784,2.48893939 12.3952027,2.33504848 12.4032881,2.1062 C12.4154356,1.75896768 12.2372727,1.59325051 11.8364003,1.59325051 C9.95758933,1.58930485 8.07463201,1.59325051 6.1959247,1.59325051 C5.81935396,1.59325051 5.44278323,1.58930485 5.0662125,1.59719616 C4.74632226,1.60508747 4.57221738,1.80236788 4.59245152,2.11802444 C4.61269728,2.42578202 4.81515152,2.5836204 5.23221128,2.5836204 L8.50388201,2.5836204 L8.50396494,2.58363636 Z M13.0713674,13.6276768 C13.0673183,14.2589899 13.5653625,14.752202 14.2010796,14.752202 C14.8367966,14.7561477 15.3550893,14.2589899 15.3631954,13.6473939 C15.3712936,13.0318586 14.8610942,12.5307677 14.2253771,12.5228687 C13.5856174,12.5149774 13.0754101,13.0042424 13.0713674,13.6276768 L13.0713674,13.6276768 Z M3.93241616,13.6237311 C3.92836705,13.0042564 3.41412348,12.518923 2.7703003,12.526822 C2.14673201,12.5347135 1.64463079,13.0200341 1.64058811,13.6316301 C1.63248989,14.2590038 2.15888079,14.7640543 2.80674665,14.7600947 C3.44246372,14.7482576 3.94052226,14.2511048 3.93241616,13.6237311 Z"
              id="Shape"
            ></path>
          </g>
        </svg>
      );
    }
  }
}
